/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PlaybackOffIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACK0lEQVR4nNVVvWsUURA/8AtBVMSgNmphoVjFSmyuUMgadj4uMDdzSZFutRRBQ6IIlhZREK39DxQsTEQQUSwFg2hhJygqigZExK8o7+3b4y67q7vkLBzY4r2Z+f3e+83svEbjf7M47mxFstvIeqEwQEQ2AdtdZLvWu8+s+5D1EpI9QdYPQLaIZI+Q9VwfOOsCsv1yJDnwJEnWANudNEDvZXvIehnZvvv93KdncuCsC26dIwCyEy4AWF/FsewUkfXAOu/3SL8h61UiPeRuGUUTG4l0d2VwLw3pexcUsx71hKwXQ9KbuNU+UKr538BTMJvslQbA9gPpT39ytOEVgYfTXg/yJEGu2SDNlTrgriZAdj6XgKTPvTxjnb0h0CdDq32wKrirSXooe5a/Adkn5xSRDWG96NaumL1xkchQmSxEk5tDd30uusEX53RBywi31NEcSR8A2/08AdsLnxgK2pUIZE9V8D8ast5Ib9A5FtangHRmIOBeEtYk/OKPq2pey9IZpB8d0OjY+K6BgmeGbMeBdOqfgPdameZAOkOk442VWOkfijYcfqIfMXeaZfnA9tC1ai3wzLrjg+1ps9lc3XVkfrBtYby8Xe6r1IoisjYbKch6MkdAOhUG5lxt8MyI2iPItgRkX4HsdKs1sWNUZDuwTWePUp+EIrIqffqqdwuynXUkBS/ckiPqC46iaB2yvXQkdVoxJj0MrDeR9R2SvUayW4jtI4XBjqSoaIOw33tjkjePEZxUAAAAAElFTkSuQmCC)
 */
export const PlaybackOffIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.7 2.7a1 1 0 0 0-1.4-1.4l-20 20a1 1 0 1 0 1.4 1.4l20-20ZM16.62 2.44c.33.11.4.53.16.78l-.83.83a.53.53 0 0 1-.5.13A6.01 6.01 0 0 0 8 10c0 .5.07.97.2 1.42.05.18 0 .38-.13.51l-.82.82c-.24.24-.65.17-.77-.15-.3-.8-.48-1.67-.48-2.6a8 8 0 0 1 10.62-7.56ZM19.95 8.05a.53.53 0 0 0-.13.5c.12.46.18.95.18 1.45a1 1 0 1 0 2 0c0-.92-.15-1.8-.44-2.62-.11-.33-.53-.4-.78-.16l-.83.83ZM11.77 16.23a.18.18 0 0 1 .24-.02c1.15.82 1.8 2.13 2.29 3.1l.02.03A3 3 0 0 0 20 18a1 1 0 1 1 2 0 5 5 0 0 1-9.47 2.24c-.53-1.06-1-1.91-1.68-2.4a.42.42 0 0 1-.05-.64l.97-.97Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5.06 14.94c.17-.17.2-.42.08-.63A8.66 8.66 0 0 1 4 10c0-2.5 1.04-4.74 2.68-6.27a1 1 0 0 0-1.36-1.46A10.55 10.55 0 0 0 2 10c0 2.06.58 3.98 1.57 5.6.17.26.53.3.75.08l.74-.74Z"
        className={colorClass}
      />
    </svg>
  );
};
